import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PropertyWithinPipeOption } from 'src/app/shared/pipes/propertyWithin/propertyWithin.pipe';
import { TrimPatternValidator } from 'src/app/shared/validators/trim-pattern/trim-pattern-validator';

import { VoucherType } from '@vi-iot/client';

import { ImmediateStateMatcher } from '@common';
import { VouchersStore } from '@store';
import { GenerateVoucherFormGroup, VoucherOption } from './generate-voucher.helper';

@Component({
  selector: 'app-generate-voucher',
  templateUrl: './generate-voucher.component.html',
  styleUrls: ['./generate-voucher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateVoucherComponent {
  copyToClipboardStatus = this.translateService.instant('+VOUCHERS.COPY_TO_CLIPBOARD');

  formGroup = new FormGroup<GenerateVoucherFormGroup>({
    voucherForm: new FormControl<VoucherOption>(null, [Validators.required]),
    customerNumber: new FormControl<string>(null, [TrimPatternValidator('^[0-9]*$')]),
  });

  matcher = new ImmediateStateMatcher();

  voucherOptions: VoucherOption[] = [
    {
      value: VoucherType.DeltaTemperatureRoomModulations,
      displayKey: '+VOUCHERS.VOUCHER_01',
    },
    {
      value: VoucherType.DeltaTemperatureRoomOnOff,
      displayKey: '+VOUCHERS.VOUCHER_02',
    },
  ];

  constructor(
    public vouchersStore: VouchersStore,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  getVoucherPropertyWithinOptions(): PropertyWithinPipeOption[] {
    const selectedVoucherOption: VoucherOption = this.formGroup.controls.voucherForm.value;
    const optionTranslation = this.translateService.instant(selectedVoucherOption.displayKey);

    return [
      {
        replaceKey: '{{type}}',
        value: optionTranslation,
      },
    ];
  }

  generateCode(): void {
    const voucherType = this.formGroup.controls.voucherForm.value.value;

    this.vouchersStore.generateSrcLiteVoucher(
      voucherType,
      this.formGroup.controls.customerNumber.value
    );
  }

  copyVoucherToClipboard(): void {
    const textToCopy = document.getElementsByClassName('voucher-code-input')[0] as any;
    textToCopy.select();
    textToCopy.setSelectionRange(0, 99999);
    document.execCommand('copy');
    this.copyToClipboardStatus = this.translateService.instant(
      '+VOUCHERS.COPY_TO_CLIPBOARD_COPIED'
    );

    setTimeout(() => {
      this.copyToClipboardStatus = this.translateService.instant('+VOUCHERS.COPY_TO_CLIPBOARD');
      this.cdr.markForCheck();
    }, 2000);
  }
}
